import StoredLayout from 'layouts/StoredLayout';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import { Row as FlexRow, Col as FlexCol } from 'react-flexbox-grid';
import DialogModal from 'cyder/modals/DialogModal';
import React from 'react';
import { connect } from 'react-redux';
import history from '../../../../history';
import { Input, Row, Col, Form, Button, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import { save, update, remove, load, generateVoters } from 'actions/staff/election/voter/action.js';

import 'css/forms/default-forms.css';

class AddPage extends React.Component {
    constructor(props) {
        super(props);

        this.back = this.back.bind(this);
        this.emailChange = this.emailChange.bind(this);

        this.nricChange = this.nricChange.bind(this);

        this.fullNameChange = this.fullNameChange.bind(this);

        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);

        this.modalToggle = this.modalToggle.bind(this);
        this.showModal = this.showModal.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.modalAction = this.modalAction.bind(this);
        this.negativeModalAction = this.negativeModalAction.bind(this);

        this.state = {
            loading: false,
            data: {
                email: '',

                nric: '',

                fullName: '',
            },
            modal: {
                showModal: false,
                modalMessage: '',
                modalHeader: '',
                positiveButtonHide: true,
                negativeButtonHide: true,
                type: 'save',
            },
        };
    }
    back() {
        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/voters`);
    }
    modalAction() {
        if (this.state.modal.type === 'deleteConfirm') {
            this.remove();
        }
    }
    negativeModalAction() {
        this.modalToggle();
    }
    showLoading(show) {
        this.setState({
            loading: show,
        });
    }
    modalToggle() {
        var modal = this.state.modal;
        modal.showModal = !modal.showModal;
        this.setState({
            modal,
        });
    }
    showModal(header, message, type, positiveButtonHide, negativeButtonHide) {
        var modal = this.state.modal;
        modal.showModal = true;
        modal.modalHeader = header;
        modal.type = type;
        modal.positiveButtonHide = positiveButtonHide;
        modal.negativeButtonHide = negativeButtonHide;
        modal.modalMessage = message;
        this.setState({
            modal,
        });
    }
    componentDidMount() {
        this.showLoading(true);
        var id = null;
        try {
            id = this.props.match.params.id;
        } catch (e) {}
        if (id != null && id > 0) {
            this.props
                .load(id)
                .then(res => {
                    this.showLoading(false);
                    if (res.error || res.data == null || res.data.id == null) {
                        this.showModal('Error', res.message, 'load', true, true);
                    } else {
                        this.setState({
                            data: res.data,
                        });
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'load', true, true);
                });
        } else {
            this.setState({
                data: {
                    email: '',

                    nric: '',

                    fullName: '',
                },
            });
            this.showLoading(false);
        }
    }
    prepareDataBeforeSave(data) {
        var newData = data;
        return newData;
    }
    save() {
        var data = this.prepareDataBeforeSave(this.state.data);
        this.showLoading(true);
        data.electionId = this.props.match.params.electionid;
        if (data.id == null || data.id === 0 || data.id === '') {
            this.props
                .save(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message, 'save', true, true);
                    } else {
                        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/voters`);
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'save', true, true);
                });
        } else {
            this.props
                .update(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message);
                    } else {
                        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/voters`, 'update', true, true);
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'update', true, true);
                });
        }
    }
    removeConfirm() {
        this.showModal('Confirmation', 'Are you sure you want to delete this record?', 'deleteConfirm', false, false);
    }
    remove() {
        var data = this.state.data;
        this.props
            .remove(data.id)
            .then(res => {
                history.replace(`/staff/elections/view/${this.props.match.params.electionid}/voters`);
            })
            .catch(error => {
                this.showModal('Error', error.message, 'delete', true, true);
            });
    }
    emailChange(e) {
        var data = this.state.data;
        data.email = e.target.value;
        this.setState({ data });
    }

    nricChange(e) {
        var data = this.state.data;
        data.nric = e.target.value;
        this.setState({ data });
    }

    fullNameChange(e) {
        var data = this.state.data;
        data.fullName = e.target.value;
        this.setState({ data });
    }

    render() {
        return this.state.loading ? (
            <LoadingSpinner />
        ) : (
            <div className="page-widget">
                <DialogModal
                    modalAction={this.modalAction}
                    negativeButtonAction={this.negativeModalAction}
                    actionToggleExternal={this.modalToggle}
                    modalOpen={this.state.modal.showModal}
                    positiveButtonHide={this.state.modal.positiveButtonHide}
                    negativeButtonHide={this.state.modal.negativeButtonHide}
                    modalBody={this.state.modal.modalMessage}
                    modalHeader={this.state.modal.modalHeader}
                />
                <Form style={{ paddingBottom: '20px' }}>
                    <Row className="mb-2">
                        <Col xs={12} className="d-flex">
                            <i onClick={this.back} style={{ cursor: 'pointer' }} className={`fa fa-2x fa-angle-left`} />
                            <div
                                style={{
                                    fontSize: '20px',
                                    marginLeft: '20px',
                                    cursor: 'pointer',
                                }}
                                onClick={this.back}
                            >
                                back
                            </div>
                        </Col>
                    </Row>
                    <hr />
                    {this.state.data.voteCast == 1 ? (
                        <div style={{ marginBottom: '30px' }}>
                            <b>
                                This voter has submitted his vote on {moment(this.state.data.voteCastTimestamp).format('DD/MM/YYYY HH:mm')}
                            </b>
                            <br />
                        </div>
                    ) : (
                        ``
                    )}
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="fullName">Full Name</Label>{' '}
                                <Input
                                    disabled={this.state.data.voteCast == 1}
                                    type="text"
                                    name="fullName"
                                    id="fullName"
                                    value={this.state.data.fullName}
                                    placeholder=""
                                    onChange={this.fullNameChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>

                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="email">Email</Label>{' '}
                                <Input
                                    type="text"
                                    disabled={this.state.data.voteCast == 1}
                                    name="email"
                                    id="email"
                                    value={this.state.data.email}
                                    placeholder=""
                                    onChange={this.emailChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="nric">NRIC</Label>{' '}
                                <Input
                                    type="text"
                                    name="nric"
                                    disabled={this.state.data.voteCast == 1}
                                    id="nric"
                                    value={this.state.data.nric}
                                    placeholder=""
                                    onChange={this.nricChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="email">Voter Key</Label>{' '}
                                <Input type="text" name="voterKey" id="voterKey" value={this.state.data.voterKey} placeholder="" disabled />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>

                    <hr />
                    <FlexRow between="xs">
                        {this.state.data.voteCast == 0 ? (
                            <FlexCol xs={2}>
                                <Button className="ml-2 align-middle primary-btn-style" onClick={this.save}>
                                    Save
                                </Button>
                            </FlexCol>
                        ) : (
                            ``
                        )}
                        {this.state.data.id > 0 && this.state.data.voteCast == 0 ? (
                            <FlexCol xs={2}>
                                <Button className="ml-2 align-middle primary-btn-style" onClick={this.removeConfirm}>
                                    Delete
                                </Button>
                            </FlexCol>
                        ) : (
                            <div />
                        )}
                    </FlexRow>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        save: data => {
            return dispatch(save(data));
        },
        generateVoters: electionId => {
            return dispatch(generateVoters(electionId));
        },
        update: data => {
            return dispatch(update(data));
        },
        remove: id => {
            return dispatch(remove(id));
        },
        load: id => {
            return dispatch(load(id));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(AddPage));
